import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBathMan1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBathMan1"><Circle cx="12" cy="4" r="2.5" stroke="currentColor"/><Path d="M15.5 22.5V16.5H17.5V8.5H6.5V16.5H8.5V22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBathMan1;
